import { getServerlessImageHandlerUrl } from '~/components/Image/helpers'

import { MetaImage } from './Metadata.types'
import { OGP_IMAGE_DIMENSIONS } from './Metadata.constants'

export function hexToRGB(
  hex: string,
  alpha?: number,
): {
  r: number
  g: number
  b: number
  alpha: number | null
} {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)

  return {
    r,
    g,
    b,
    ...(typeof alpha !== 'undefined' ? { alpha } : { alpha: null }),
  }
}

export function getCloudfrontUrl(
  { srcKey, backgroundColor, fillColor, fit }: Partial<MetaImage> & { srcKey: string },
  { height, width }: { height: number; width: number } = OGP_IMAGE_DIMENSIONS,
): string {
  return getServerlessImageHandlerUrl({
    key: srcKey,
    edits: {
      resize: {
        width,
        height,
        fit: fit ?? 'cover',
        ...(backgroundColor
          ? {
              background: hexToRGB(backgroundColor, 1),
            }
          : undefined),
      },
      toFormat: 'png',
      ...(fillColor
        ? {
            flatten: {
              background: hexToRGB(fillColor),
            },
          }
        : undefined),
    },
  })
}
